// '새 계정' 판정 — Supabase는 인증번호를 '보낼 때' 계정을 만든다. 그래서 '생성 10초·60초 안'으로 새 계정을 가리면
// 번호를 늦게 친 사람이 빠진다. 서버 추천 관계 가드(referral_link_guard_and_snapshot: 계정 생성 30분 안)와 같은 30분을 쓴다.
// 2026-10-22 실측(최근 7일 인증까지 마친 새 회원 6,490명): 10초 기준은 약관 동의 기록·가입 접속 정보가 90.7% 빠졌고,
// 60초 기준은 1분 넘게 걸린 8.3%(536명)가 추천인 연결을 못 받았다(연결 1명, 1분 안 인증자는 85.4% 연결). 문서: Readme/SignupFreshAccount.md
export const FRESH_ACCOUNT_MS = 30 * 60 * 1000;

export const isFreshAccount = (createdAt?: string | null): boolean =>
    !!createdAt && Date.now() - new Date(createdAt).getTime() < FRESH_ACCOUNT_MS;
